import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./CreateBankForm.css";
import Modal from "react-bootstrap/Modal";
import MapWrapper from "../../../../Components/UiComponents/MapWrapper/MapWrapper";
import {
  findRegionsByUser,
  getThemeURL,
  createBankDetails,
  updateBankDetails,
} from "../../../../Services/EndPoints";

// API services
import {
  postDataWithBody,
  getData,
  putDataWithBody,
} from "../../../../Services/Services";

// import LocationAutoComplete from "./LocationAutoComplete"; // Adjust the path as needed
import { XCircleblack } from "../../../../Components/IconComponents";
import MapWrapperForEdit from "../../IncidentManagement/AddIncidentForm/MapWarapperForEdit";

// Component for displaying Create/Edit Bank form
const CreateBankForm = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const location = useLocation();
  const { isTextFieldDisable } = location.state || {};
  let data = state?.data;
  let formDataToEditt = state?.formDataToEdit;
  let mapview = state?.edit;
  const [loader, setLoader] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [districtList, setDistrictList] = useState([]);
  const [userId, setUserId] = useState(null);

  // Map related states
  const [showMapModal, setShowMapModal] = useState(false);
  const [coordinates, setCoordinates] = useState([
    {
      y: 85.562, // default longitude
      x: 25.747, // default latitude
    },
  ]);

  const [zoomLevel, setZoomLevel] = useState(8);
  const [mapKey, setMapKey] = useState(0);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [existingImageData, setExistingImageData] = useState(null);
  const [imageToRemove, setImageToRemove] = useState(false);
  const [fontStyles, setFontStyles] = useState({
    bankNameFontSize: "18",
    bankNameColor: "#000000",
  });

  // Validation errors state
  const [validationErrors, setValidationErrors] = useState({
    bankName: "",
    district: "",
    ifscCode: "",
    entryDate: "",
    addressLine1: "",
    addressLine2: "",
    pinCode: "",
    city: "",
    mandal: "",
    phoneNumber: "",
    email: "",
    contactName: "",
    website: "",
    latitude: "",
    longitude: "",
  });

  // Form data state
  const [formData, setFormData] = useState({
    bankName: "",
    district: "",
    ifscCode: "",
    activeStatus: false,
    entryDate: "",
    addressLine1: "",
    addressLine2: "",
    pinCode: "",
    city: "",
    mandal: "",
    state: "",
    phoneNumber: "",
    email: "",
    latitude: "",
    longitude: "",
  });

  console.log("Edit table data", formDataToEditt);
  // Helper function to convert byte array to base64
  // Helper function to convert byte array to base64 - IMPROVED VERSION
  const byteArrayToBase64 = (byteArray) => {
    if (!byteArray || !Array.isArray(byteArray) || byteArray.length === 0) {
      console.log("Invalid byte array:", byteArray);
      return null;
    }

    try {
      // Convert array to Uint8Array if needed
      const uint8Array =
        byteArray instanceof Uint8Array ? byteArray : new Uint8Array(byteArray);

      // Convert to binary string
      let binary = "";
      const chunkSize = 8192; // Process in chunks to avoid call stack issues

      for (let i = 0; i < uint8Array.length; i += chunkSize) {
        const chunk = uint8Array.slice(i, i + chunkSize);
        binary += String.fromCharCode.apply(null, chunk);
      }

      // Convert to base64
      const base64 = btoa(binary);

      // Return with proper data URL prefix
      return "data:image/png;base64," + base64;
    } catch (error) {
      console.error("Error converting byte array to base64:", error);
      return null;
    }
  };

  // Function to convert timestamp to "yyyy-mm-dd" format (for date input)
const timestampToDateInputFormat = (timestamp) => {
  if (!timestamp) return new Date().toISOString().split('T')[0];
  
  try {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) {
      return new Date().toISOString().split('T')[0];
    }
    
    // Format as yyyy-mm-dd for date input
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error('Error converting timestamp:', error);
    return new Date().toISOString().split('T')[0];
  }
};

// Function to convert timestamp to "dd-mm-yyyy" format for display
const timestampToDisplayFormat = (timestamp) => {
  if (!timestamp) {
    const today = new Date();
    return today.toLocaleDateString('en-IN'); // This gives dd/mm/yyyy format
  }
  
  try {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) {
      return new Date().toLocaleDateString('en-IN');
    }
    
    return date.toLocaleDateString('en-IN'); // Converts to dd/mm/yyyy format
  } catch (error) {
    console.error('Error converting timestamp to display format:', error);
    return new Date().toLocaleDateString('en-IN');
  }
};

  // Function for form reset
  // Function for form reset - CORRECTED VERSION
  // Function for form reset - CORRECTED VERSION
  const resetForm = (data) => {
    // Create a new form object
    const newFormData = {
      bankName: data?.bankName || "",
      district: data?.district || "",
      ifscCode: data?.ifscCode || "",
      activeStatus: data?.activeStatus || false,
      entryDate: timestampToDateInputFormat(data?.entryDate),
      addressLine1: data?.addressLine1 || "",
      addressLine2: data?.addressLine2 || "",
      pinCode: data?.pinCode || "",
      city: data?.city || "",
      mandal: data?.mandal || "",
      state: data?.state || "",
      phoneNumber: data?.phoneNumber || "",
      email: data?.email || "",
      contactName: data?.contactName || "",
      website: data?.website || "",
      latitude: data?.latitude || "",
      longitude: data?.longitude || "",
    };

    // Handle font styles
    setFontStyles({
      bankNameFontSize:
        data?.fontStyles?.bankNameFontSize ||
        data?.banknameFontsize?.replace("px", "") ||
        "18", // Make sure this is a string
      bankNameColor:
        data?.fontStyles?.bankNameColor || data?.banknameColour || "#000000",
    });

    // Handle existing image data - THIS IS THE KEY FIX
    if (data?.image) {
      // If image is a byte array (from database)
      if (Array.isArray(data.image)) {
        const base64Image = byteArrayToBase64(data.image);
        if (base64Image) {
          setExistingImageData(data.image); // Store original byte array
          setLogoPreview(base64Image); // Set preview
        }
      }
      // If image is already base64 string with data URL prefix
      else if (
        typeof data.image === "string" &&
        data.image.startsWith("data:image/")
      ) {
        setLogoPreview(data.image);
        setExistingImageData(data.image);
      }
      // If image is base64 string WITHOUT data URL prefix (your case)
      else if (typeof data.image === "string" && data.image.length > 0) {
        // Add the data URL prefix to make it displayable
        const dataUrl = `data:image/png;base64,${data.image}`;
        setLogoPreview(dataUrl);
        setExistingImageData(data.image); // Store original base64 string
      }
    }

    // Reset image removal flag
    setImageToRemove(false);

    // Use setTimeout to ensure this happens after React has processed other state updates
    setTimeout(() => {
      setFormData(newFormData);
      console.log("Form reset with data:", newFormData);
    }, 0);

    // Update map if coordinates exist
    if (data?.latitude && data?.longitude) {
      const lat = parseFloat(data.latitude);
      const lng = parseFloat(data.longitude);

      if (!isNaN(lat) && !isNaN(lng)) {
        setCoordinates([{ y: lng, x: lat }]);
        setZoomLevel(16);
      }
    }
  };

  // In your component, add this useEffect
  // Updated useEffect with debugging
  useEffect(() => {
    // Initial component load
    if (formDataToEditt) {
      console.log("Found edit data on initial load");
      console.log("formDataToEditt:", formDataToEditt);
      console.log("formDataToEditt.image:", formDataToEditt.image);
      console.log("Image type:", typeof formDataToEditt.image);
      console.log("Is array:", Array.isArray(formDataToEditt.image));

      if (formDataToEditt.image && Array.isArray(formDataToEditt.image)) {
        console.log("Image array length:", formDataToEditt.image.length);
        console.log("First few bytes:", formDataToEditt.image.slice(0, 10));
      }

      resetForm(formDataToEditt);
    }
  }, [formDataToEditt]);
  // Get today's date for date field max attribute
  const today = new Date().toISOString().split("T")[0];

  // Function to choose coordinates from map
  const chooseCoordinates = (longitude, latitude) => {
    // Update form data
    setFormData({
      ...formData,
      longitude: longitude,
      latitude: latitude,
    });

    // Update coordinates for the map
    setCoordinates([
      {
        y: longitude,
        x: latitude,
      },
    ]);

    // // Set center coordinates for the map
    // setMapCenterCoordinates({
    //   y: longitude,
    //   x: latitude,
    // });

    // Optional: Reset map key to force re-render
    setMapKey((prevKey) => prevKey + 1);
  };

  // Function to update map location from search
  // const updateMapLocation = (lat, lng) => {
  //   setCoordinates([{ y: lng, x: lat }]);
  //   setFormData({
  //     ...formData,
  //     latitude: lat,
  //     longitude: lng,
  //   });
  //   // setMapCenterCoordinates({
  //   //   y: lng,
  //   //   x: lat,
  //   // });
  //   setZoomLevel(16);
  //   setMapKey((prevKey) => prevKey + 1);
  // };

  // Function to open map modal
  const openMapModal = () => {
    setShowMapModal(true);
  };

  // Function to close map modal
  const closeMapModal = () => {
    setShowMapModal(false);
  };

  // Fetch District list
  useEffect(() => {
    fetchDistrictList();
  }, []);

  useEffect(() => {
    fetchUserProfile();
  }, []);

  // Initialize form with data if available
  useEffect(() => {
    if (data) {
      setFormData({
        ...formData,
        ...data,
      });

      // Initialize map coordinates if available
      if (data.latitude && data.longitude) {
        setCoordinates([
          {
            y: data.longitude,
            x: data.latitude,
          },
        ]);
      }
    }
  }, [data]);

  // Validate bank name
  const validateBankName = (value) => {
    if (!value || !value.trim()) {
      return "Bank Name is required";
    }
    if (value.trim().length < 3) {
      return "Bank Name must be at least 3 characters";
    }
    if (value.trim().length > 50) {
      return "Bank Name must be less than 50 characters";
    }
    if (!/^[a-zA-Z0-9 ]+$/.test(value)) {
      return "Bank Name can only contain letters, numbers, and spaces";
    }
    return "";
  };

  // Validate latitude
  const validateLatitude = (value) => {
    // Handle undefined, null, or non-string values
    if (value === undefined || value === null) {
      return "";
    }

    // Convert to string if it's a number
    const strValue = String(value);

    // If empty string, it's optional so return no error
    if (!strValue || strValue.trim() === "") {
      return "";
    }

    // Check if it only contains numbers and decimal point
    if (!/^-?\d*\.?\d*$/.test(strValue)) {
      return "Latitude must contain only numbers and decimal point";
    }

    // Check if it has more than 14 decimal places
    const decimalPart = strValue.toString().split(".");
    if (decimalPart.length > 1 && decimalPart[1].length > 16) {
      return "Latitude can have maximum 16 digits after decimal point";
    }

    // Check if it's a valid latitude value (between -90 and 90)
    const latValue = parseFloat(strValue);
    if (isNaN(latValue) || latValue < -90 || latValue > 90) {
      return "Latitude must be a valid number between -90 and 90";
    }

    return "";
  };

  // Validate longitude
  const validateLongitude = (value) => {
    // Handle undefined, null, or non-string values
    if (value === undefined || value === null) {
      return "";
    }

    // Convert to string if it's a number
    const strValue = String(value);

    // If empty string, it's optional so return no error
    if (!strValue || strValue.trim() === "") {
      return "";
    }

    // Check if it only contains numbers and decimal point
    if (!/^-?\d*\.?\d*$/.test(strValue)) {
      return "Longitude must contain only numbers and decimal point";
    }

    // Check if it has more than 14 decimal places
    const decimalPart = strValue.toString().split(".");
    if (decimalPart.length > 1 && decimalPart[1].length > 16) {
      return "Longitude can have maximum 16 digits after decimal point";
    }

    // Check if it's a valid longitude value (between -180 and 180)
    const lngValue = parseFloat(strValue);
    if (isNaN(lngValue) || lngValue < -180 || lngValue > 180) {
      return "Longitude must be a valid number between -180 and 180";
    }

    return "";
  };

  // Validate Pincode
  const validatePinCode = (value) => {
    if (!value || !value.trim()) {
      return "Pincode is required";
    }
    if (!/^[1-9][0-9]{5}$/.test(value)) {
      return "Pincode must be 6 digits and start with a non-zero digit";
    }
    return "";
  };

  // Validate City and Mandal
  const validateCityOrMandal = (value, fieldName) => {
    if (!value || !value.trim()) {
      return `${fieldName} is required`;
    }
    if (!/^[a-zA-Z\s]+$/.test(value)) {
      return `${fieldName} must contain letters and spaces only`;
    }
    if (value.trim().length > 50) {
      return `${fieldName} must be less than 50 characters`;
    }
    return "";
  };

  // Validate Phone/Landline
  const validatePhoneNumber = (value) => {
    // If empty, it's not required anymore
    if (!value || !value.trim()) {
      return "Mobile/Landline Number is required";
    }

    // Check if it's a 10-digit mobile number
    if (/^[6-9]\d{9}$/.test(value)) {
      return "";
    }

    // Check if it's a landline number
    if (/^[0]\d{1,3}[-\s]?\d{6,8}$/.test(value)) {
      return "";
    }

    return "Enter a valid 10-digit mobile number or landline number (STD code + number)";
  };

  // Validate Email
  const validateEmail = (value) => {
    // If empty, it's not required anymore
    if (!value || !value.trim()) {
      return "Email Address is required";
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return "Enter a valid email address (e.g., user@example.com)";
    }
    return "";
  };

  // Validate Contact Name
  const validateContactName = (value) => {
    if (!value || !value.trim()) {
      return "Contact Name is required";
    }
    if (value.trim().length < 3) {
      return "Contact Name must be at least 3 characters";
    }
    if (value.trim().length > 50) {
      return "Contact Name must be less than 50 characters";
    }
    if (!/^[a-zA-Z0-9 ]+$/.test(value)) {
      return "Contact Name can only contain letters, numbers, and spaces";
    }
    return "";
  };

  // Validate Website
  const validateWebsite = (value) => {
    // If empty, it's not required anymore
    if (!value || !value.trim()) {
      return "";
    }

    // Rest of the validation logic
    let urlToValidate = value;
    if (!/^https?:\/\//i.test(value)) {
      urlToValidate = "http://" + value;
    }

    try {
      const url = new URL(urlToValidate);
      if (
        !/^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(
          url.hostname
        )
      ) {
        return "Enter a valid website URL (e.g., example.com)";
      }
      return "";
    } catch (e) {
      return "Enter a valid website URL (e.g., example.com)";
    }
  };
  // Validate district
  const validateDistrict = (value) => {
    if (!value || !value.trim()) {
      return "District is required";
    }
    return "";
  };

  // Validate IFSC code
  const validateIFSCCode = (value) => {
    if (!value || !value.trim()) {
      return "IFSC Code is required";
    }
    if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)) {
      return "IFSC Code must follow the format: 4 letters, 0, and 6 alphanumeric characters";
    }
    return "";
  };

  // Validate address
  const validateAddress = (value, fieldName, isRequired = true) => {
    // If field is not required and empty, return no error
    if (!isRequired && (!value || !value.trim())) {
      return "";
    }

    // Required field validation
    if (isRequired && (!value || !value.trim())) {
      return `${fieldName} is required`;
    }

    // Length validation for non-empty values
    if (value && value.trim().length < 5) {
      return `${fieldName} must be at least 5 characters`;
    }
    if (value && value.trim().length > 100) {
      return `${fieldName} must be less than 100 characters`;
    }

    // Character validation
    if (value && !/^[a-zA-Z0-9 ,\-/.]+$/.test(value)) {
      return `${fieldName} can only contain letters, numbers, commas, hyphens, slashes, dots, and spaces`;
    }

    return "";
  };

  // Validate date
  const validateDate = (value) => {
    if (!value) {
      return "Date is required";
    }

    const selectedDate = new Date(value);
    const currentDate = new Date();

    // Check if valid date
    if (isNaN(selectedDate.getTime())) {
      return "Please enter a valid date";
    }

    // Reset time components for accurate date comparison
    selectedDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    if (selectedDate > currentDate) {
      return "Date cannot be in the future";
    }
    return "";
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { id, value, type, checked } = e.target;

    if (type === "checkbox" && id === "activeStatusCheck") {
      setFormData({ ...formData, activeStatus: checked });
    } else {
      setFormData({ ...formData, [id]: value });

      // Validate fields on change
      let error = "";
      switch (id) {
        case "bankName":
          error = validateBankName(value);
          break;
        case "district":
          error = validateDistrict(value);
          break;
        case "ifscCode":
          error = validateIFSCCode(value);
          break;
        case "entryDate":
          error = validateDate(value);
          break;
        case "addressLine1":
          error = validateAddress(value, "Address Line", true);
          break;
        case "addressLine2":
          error = validateAddress(value, "Address Line 2", false);
          break;
        case "latitude":
          error = validateLatitude(value);
          break;
        case "longitude":
          error = validateLongitude(value);
          break;
        case "pinCode":
          error = validatePinCode(value);
          break;
        case "city":
          error = validateCityOrMandal(value, "City");
          break;
        case "mandal":
          error = validateCityOrMandal(value, "Mandal");
          break;
        case "phoneNumber":
          error = validatePhoneNumber(value);
          break;
        case "email":
          error = validateEmail(value);
          break;
        case "contactName":
          error = validateContactName(value);
          break;
        case "website":
          error = validateWebsite(value);
          break;
        default:
          break;
      }

      setValidationErrors({
        ...validationErrors,
        [id]: error,
      });
    }
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type (JPEG, PNG, SVG only)
      const validTypes = ["image/jpeg", "image/png", "image/svg+xml"];
      const validExtensions = [".jpg", ".jpeg", ".png", ".svg"];

      const fileExtension = file.name.split(".").pop().toLowerCase();
      const isValidType =
        validTypes.includes(file.type) ||
        validExtensions.includes(`.${fileExtension}`);

      if (!isValidType) {
        toast.error(
          "Please upload a valid image file (JPEG, PNG, or SVG only)"
        );
        e.target.value = ""; // Clear the invalid file
        return;
      }

      // Validate file size (max 2MB)
      if (file.size > 2 * 1024 * 1024) {
        toast.error("File size should be less than 2MB");
        e.target.value = ""; // Clear the oversized file
        return;
      }

      setLogoFile(file);
      setExistingImageData(null); // Clear existing image data when new file is selected
      setImageToRemove(false); // Reset remove flag

      // Create preview (except for SVG which can't be previewed directly)
      if (file.type !== "image/svg+xml") {
        const reader = new FileReader();
        reader.onloadend = () => {
          setLogoPreview(reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        // For SVG files, we'll just store the file (preview not possible)
        setLogoPreview(null);
      }
    }
  };

  const handleLogoRemove = () => {
    setLogoFile(null);
    setLogoPreview(null);

    // Clear the file input value
    const fileInput = document.getElementById("bankLogo");
    if (fileInput) {
      fileInput.value = "";
    }

    // If we had existing image data, mark it for removal
    if (existingImageData) {
      setImageToRemove(true);
      setExistingImageData(null);
    }

    // Also clear any existing logo in formData if editing
    setFormData({
      ...formData,
      logoUrl: "",
    });
  };

  const fetchUserProfile = async () => {
    try {
      const response = await getData(getThemeURL);
      if (response && Array.isArray(response) && response.length > 0) {
        setUserId(response[0].id); // Get `id` from the first user
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  // Fetch district list from API
  const fetchDistrictList = async () => {
    setLoader(true);
    try {
      const response = await getData(findRegionsByUser);
      if (response && Array.isArray(response)) {
        setDistrictList(response);
      } else {
        console.error("Invalid banks data format:", response);
        toast.error("Failed to load banks data");
      }
    } catch (error) {
      console.error("Error fetching banks:", error);
      toast.error("Failed to load banks data");
    } finally {
      setLoader(false);
    }
  };

  const validateForm = () => {
    const errors = {
      bankName: validateBankName(formData.bankName),
      district: validateDistrict(formData.district),
      ifscCode: validateIFSCCode(formData.ifscCode),
      entryDate: validateDate(formData.entryDate),
      addressLine1: validateAddress(formData.addressLine1, "Address", true),
      addressLine2: validateAddress(
        formData.addressLine2,
        "Address Line 2",
        false
      ),
      pinCode: validatePinCode(formData.pinCode),
      city: validateCityOrMandal(formData.city, "City"),
      mandal: validateCityOrMandal(formData.mandal, "Mandal"),
      phoneNumber: validatePhoneNumber(formData.phoneNumber),
      email: validateEmail(formData.email),
      contactName: validateContactName(formData.contactName),
      website: validateWebsite(formData.website),
      latitude: validateLatitude(formData.latitude),
      longitude: validateLongitude(formData.longitude),
    };

    setValidationErrors(errors);

    // Form is valid if no error messages exist
    return !Object.values(errors).some((error) => error !== "");
  };

  // Submit the form data
  const handleSubmit = async () => {
    // Validate form before submission
    if (!validateForm()) {
      toast.error("Please correct the validation errors", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      return;
    }

    setIsSubmitting(true);
    setLoader(true);

    try {
      // Handle image data
      let imageData = null;

      if (logoFile) {
        // New file uploaded - convert to byte array
        imageData = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (event) => {
            const arrayBuffer = event.target.result;
            const byteArray = new Uint8Array(arrayBuffer);
            resolve(Array.from(byteArray)); // Convert to regular array for JSON serialization
          };
          reader.onerror = (error) => reject(error);
          reader.readAsArrayBuffer(logoFile);
        });
      } else if (existingImageData && !imageToRemove) {
        // Keep existing image data
        if (Array.isArray(existingImageData)) {
          // If it's already a byte array
          imageData = existingImageData;
        } else if (typeof existingImageData === "string") {
          // If it's a base64 string, convert to byte array
          try {
            const base64Data = existingImageData.includes(",")
              ? existingImageData.split(",")[1]
              : existingImageData;
            const binaryString = atob(base64Data);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
              bytes[i] = binaryString.charCodeAt(i);
            }
            imageData = Array.from(bytes);
          } catch (error) {
            console.error("Error converting base64 to byte array:", error);
            imageData = null;
          }
        }
      } else if (imageToRemove) {
        // Image was removed - send null
        imageData = null;
      }

      // Build the complete payload
      const payload = {
        ...formData,
        is_deleted: false,
        state: "Bihar",
        image: imageData,
        banknameFontsize: `${fontStyles.bankNameFontSize}px`,
        banknameColour: fontStyles.bankNameColor,
      };

      // For create operation
      if (!formDataToEditt) {
        payload.created_by = userId;

        // Make API call for create
        const response = await postDataWithBody(createBankDetails, payload, {});

        if (response.status === "success") {
          toast.success("Bank created successfully", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          navigate("/branches/bank-list"); // Redirect to banks list page
          setTimeout(() => {
            window.location.reload();
          }, 100);
        } else {
          toast.error(response.msg || "Failed to create bank details", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
        }
      }
      // For update operation
      else {
        // Add required fields for update
        payload.id = formDataToEditt.id;
        payload.updated_by = userId;

        // Make API call for update
        const response = await putDataWithBody(updateBankDetails, payload, {});

        if (response.status === "success") {
          toast.success("Bank updated successfully", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          navigate("/branches/bank-list"); // Redirect to banks list page
          setTimeout(() => {
            window.location.reload();
          }, 100);
        } else {
          toast.error(response.msg || "Failed to update bank details", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("An error occurred while submitting the form", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setLoader(false);
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    setShowCancelModal(true);
  };
  const confirmCancel = () => {
    resetForm1();
    setShowCancelModal(false);
  };

  // Close cancel modal without resetting
  const closeCancelModal = () => {
    setShowCancelModal(false);
  };
  const resetForm1 = () => {
    // Reset main form data
    setFormData({
      bankName: "",
      district: "",
      ifscCode: "",
      activeStatus: false,
      entryDate: new Date().toISOString().split("T")[0],
      addressLine1: "",
      addressLine2: "",
      pinCode: "",
      city: "",
      mandal: "",
      state: "",
      phoneNumber: "",
      email: "",
      latitude: "",
      longitude: "",
      contactName: "",
      website: "",
    });

    // Reset image-related states
    setLogoFile(null);
    setLogoPreview(null);
    setExistingImageData(null);
    setImageToRemove(false);

    // Clear the file input
    const fileInput = document.getElementById("bankLogo");
    if (fileInput) {
      fileInput.value = "";
    }

    // Reset coordinates for map
    setCoordinates([
      {
        y: 85.562, // default longitude
        x: 25.747, // default latitude
      },
    ]);

    // Reset validation errors
    setValidationErrors({
      bankName: "",
      district: "",
      ifscCode: "",
      entryDate: "",
      addressLine1: "",
      addressLine2: "",
      pinCode: "",
      city: "",
      mandal: "",
      phoneNumber: "",
      email: "",
      contactName: "",
      website: "",
      latitude: "",
      longitude: "",
    });
  };

  const mapCoordinates = [
    {
      x: formData.latitude,
      y: formData.longitude,
      locationId: 1,
    },
  ];

  return (
    <>
      {!mapview ? (
        <>
          <div className="branch-main-container">
            {/* Tab Content */}
            <div className="tab-content" id="branchTabContent">
              {/* Branch Details Tab */}
              <div
                className="tab-pane fade show active"
                id="branch-details"
                role="tabpanel"
                aria-labelledby="branch-details-tab"
              >
                <div className="main-container">
                  <div className="row">
                    <div className="col-8 mb-3">
                      <label htmlFor="bankName" className="form-label">
                        Bank Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.bankName ? "is-invalid" : ""
                        }`}
                        id="bankName"
                        value={formData.bankName}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                      />
                      {validationErrors.bankName && (
                        <div className="invalid-feedback">
                          {validationErrors.bankName}
                        </div>
                      )}
                    </div>
                    <div className="col-2 mb-3">
                      <label htmlFor="bankName" className="form-label">
                        Font Size (px)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        min="18"
                        max="30"
                        step="1"
                        value={fontStyles.bankNameFontSize}
                        onChange={(e) => {
                          let value = e.target.value;
                          // Ensure value is between 8 and 72
                          if (value > 30) value = 30;
                          if (value < 18) value = 18;
                          setFontStyles({
                            ...fontStyles,
                            bankNameFontSize: value,
                          });
                        }}
                        disabled={isTextFieldDisable}
                      />
                    </div>
                    <div className="col-2 mb-3">
                      <label htmlFor="bankNameColor" className="form-label">
                        Font Color
                        <i
                          className="bi bi-eyedropper"
                          style={{
                            paddingLeft: "5px",
                            fontSize: "16px",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            document.getElementById("bankNameColor").click()
                          }
                        ></i>
                      </label>
                      <input
                        type="color"
                        id="bankNameColor"
                        style={{ width: "50%" }}
                        className="form-control form-control-sm p-1"
                        value={fontStyles.bankNameColor}
                        onChange={(e) =>
                          setFontStyles({
                            ...fontStyles,
                            bankNameColor: e.target.value,
                          })
                        }
                        disabled={isTextFieldDisable}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-3 mb-3">
                      <label htmlFor="district" className="form-label">
                        District<span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-select branch-input-form-control ${
                          validationErrors.district ? "is-invalid" : ""
                        }`}
                        id="district"
                        value={formData.district}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                      >
                        <option value="">Select District</option>
                        {districtList.map((district) => (
                          <option key={district.id} value={district.value}>
                            {district.value}
                          </option>
                        ))}
                      </select>
                      {validationErrors.district && (
                        <div className="invalid-feedback">
                          {validationErrors.district}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="ifscCode" className="form-label">
                        IFSC Code<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.ifscCode ? "is-invalid" : ""
                        }`}
                        id="ifscCode"
                        value={formData.ifscCode}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        // ="Example: DCCB0123456"
                        maxLength={11}
                      />
                      {validationErrors.ifscCode && (
                        <div className="invalid-feedback">
                          {validationErrors.ifscCode}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="activationDate" className="form-label">
                        Active Status
                      </label>
                      <div className="d-flex align-items-center gap-2">
                        <input
                          className="form-check-input branch-active-status-checkbox"
                          type="checkbox"
                          id="activeStatusCheck"
                          checked={formData.activeStatus}
                          onChange={handleInputChange}
                          disabled={isTextFieldDisable}
                        />
                        <input
                          type="date"
                          className={`custom-date-input form-control ${
                            validationErrors.entryDate ? "is-invalid" : ""
                          }`}
                          id="entryDate"
                          style={{paddingBottom: "7px"}}
                          value={formData.entryDate}
                          onChange={handleInputChange}
                          disabled={isTextFieldDisable}
                          max={today}
                        />
                        {validationErrors.entryDate && (
                          <div className="invalid-feedback">
                            {validationErrors.entryDate}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="section-header-branch">
                    <span className="uline">Bank Address</span>
                  </div>
                  <div className="row">
                    <div className="col-3 mb-3">
                      <label htmlFor="addressLine1" className="form-label">
                        Address<span className="text-danger">*</span>
                      </label>
                      <textarea
                        className={`form-control branch-input-form-control ${
                          validationErrors.addressLine1 ? "is-invalid" : ""
                        }`}
                        id="addressLine1"
                        value={formData.addressLine1}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        // ="Enter address"
                        rows={3} // You can adjust rows based on how big you want it
                      />
                      {validationErrors.addressLine1 && (
                        <div className="invalid-feedback">
                          {validationErrors.addressLine1}
                        </div>
                      )}
                    </div>

                    <div className="col-3 mb-3">
                      <label htmlFor="mandal" className="form-label">
                        Mandal<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.mandal ? "is-invalid" : ""
                        }`}
                        id="mandal"
                        value={formData.mandal}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        maxLength={50}
                        // ="Enter mandal name"
                      />
                      {validationErrors.mandal && (
                        <div className="invalid-feedback">
                          {validationErrors.mandal}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="city" className="form-label">
                        City<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.city ? "is-invalid" : ""
                        }`}
                        id="city"
                        value={formData.city}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        maxLength={50}
                        // ="Enter city name"
                      />
                      {validationErrors.city && (
                        <div className="invalid-feedback">
                          {validationErrors.city}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="pinCode" className="form-label">
                        Pincode<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.pinCode ? "is-invalid" : ""
                        }`}
                        id="pinCode"
                        value={formData.pinCode}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        maxLength={6}
                        // ="Enter 6-digit pincode"
                      />
                      {validationErrors.pinCode && (
                        <div className="invalid-feedback">
                          {validationErrors.pinCode}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-3 mb-3">
                      <label htmlFor="latitude" className="form-label mb-0">
                        Latitude
                      </label>
                      <input
                        type="text"
                        className="form-control branch-input-form-control mt-1"
                        id="latitude"
                        value={formData.latitude}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        readOnly
                      />
                      {validationErrors.latitude && (
                        <div className="text-danger small">
                          {validationErrors.latitude}
                        </div>
                      )}
                    </div>

                    <div className="col-3 mb-3">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <label htmlFor="longitude" className="form-label ">
                          Longitude
                        </label>
                        <span
                          className="text-primary"
                          onClick={
                            !isTextFieldDisable ? openMapModal : undefined
                          }
                          style={{
                            cursor: isTextFieldDisable
                              ? "not-allowed"
                              : "pointer",
                            opacity: isTextFieldDisable ? 0.5 : 1,
                            fontSize: "14px",
                          }}
                        >
                          Locate on map
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control branch-input-form-control"
                        id="longitude"
                        value={formData.longitude}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        readOnly
                      />
                      {validationErrors.longitude && (
                        <div className="text-danger small">
                          {validationErrors.longitude}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="section-header-branch">
                    <span className="uline">Bank Contact Details</span>
                  </div>
                  <div className="row">
                    <div className="col-6 mb-3">
                      <label htmlFor="phoneNumber" className="form-label">
                        Mobile/Landline Number
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.phoneNumber ? "is-invalid" : ""
                        }`}
                        id="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        // ="Mobile: 10 digits, Landline: STD code + number"
                      />
                      {validationErrors.phoneNumber && (
                        <div className="invalid-feedback">
                          {validationErrors.phoneNumber}
                        </div>
                      )}
                    </div>

                    {/* Update the Contact Name field */}
                    <div className="col-6 mb-3">
                      <label htmlFor="contactName" className="form-label">
                        Contact Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.contactName ? "is-invalid" : ""
                        }`}
                        id="contactName"
                        value={formData.contactName}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        // ="Enter contact person name"
                      />
                      {validationErrors.contactName && (
                        <div className="invalid-feedback">
                          {validationErrors.contactName}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 mb-3">
                      <label htmlFor="email" className="form-label">
                        Email Address<span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className={`form-control branch-input-form-control ${
                          validationErrors.email ? "is-invalid" : ""
                        }`}
                        id="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        // ="Enter email address e.g. user@example.com"
                      />
                      {validationErrors.email && (
                        <div className="invalid-feedback">
                          {validationErrors.email}
                        </div>
                      )}
                    </div>

                    {/* Update the Website field */}
                    <div className="col-6 mb-3">
                      <label htmlFor="website" className="form-label">
                        Website
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.website ? "is-invalid" : ""
                        }`}
                        id="website"
                        value={formData.website}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                      />
                      {validationErrors.website && (
                        <div className="invalid-feedback">
                          {validationErrors.website}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 mb-3">
                      <label htmlFor="bankLogo" className="form-label">
                        Bank Logo
                      </label>
                      <input
                        type="file"
                        id="bankLogo"
                        accept=".jpg, .jpeg, .png, .svg, image/jpeg, image/png, image/svg+xml"
                        onChange={handleLogoChange}
                        className="form-control branch-input-form-control"
                      />
                      {logoPreview && (
                        <div
                          className="mt-2 position-relative"
                          style={{ width: "100px", height: "100px" }}
                        >
                          <img
                            src={logoPreview}
                            alt="Bank Logo Preview"
                            className="img-thumbnail"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                            }}
                          />
                          {!isTextFieldDisable && (
                            <button
                              onClick={handleLogoRemove}
                              className="position-absolute top-0 end-0 bg-danger border-0 rounded-circle p-0"
                              style={{
                                width: "24px",
                                height: "24px",
                                transform: "translate(50%, -50%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              aria-label="Remove logo"
                            >
                              <span
                                style={{ color: "white", fontSize: "12px" }}
                              >
                                ×
                              </span>
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  {mapview && (
                    <div style={{ width: "50%", height: "100%" }}>
                      <MapWrapperForEdit
                        title="Incidents"
                        containerStyles={{
                          height: "100%",
                          borderRadius: "10px",
                          // height: "100vh",
                          display: "flex",
                          flexDirection: "column",
                        }}
                        headerStyles={{
                          backgroundColor: "#1a7a73",
                          color: "white",
                          padding: "8px 16px",
                        }}
                        bodyStyles={{
                          flex: 1,
                          overflow: "hidden",
                        }}
                        coordinates={mapCoordinates}
                        zoom={13}
                        popUpShow={true}
                      />
                    </div>
                  )}
                  <div className="d-flex justify-content-center mt-3">
                    <button
                      className="branch-save-submit-btn btn btn-success"
                      onClick={handleSubmit}
                      disabled={isSubmitting || isTextFieldDisable}
                    >
                      {isSubmitting ? "Submitting..." : "Save & Submit"}
                    </button>
                    <button
                      type="button"
                      className="branch-save-submit-btn btn btn-success"
                      style={{ marginLeft: "15px" }}
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Display loading indicator */}
          {loader && (
            <div className="loader-container">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          {showMapModal && (
            <Modal
              className="modal-position"
              size="lg"
              show={showMapModal}
              onHide={closeMapModal}
              aria-labelledby="example-modal-sizes-title-lg"
              right
            >
              <Modal.Header>
                <Modal.Title
                  id="example-modal-sizes-title-lg"
                  style={{ color: "#001b30", marginRight: "500px" }}
                >
                  {"Choose Location"}
                </Modal.Title>
                <XCircleblack
                  className="cursor-pointer"
                  onClick={closeMapModal}
                  width="1.5em"
                  height="1.5em"
                  style={{ color: "#001b30" }}
                />
              </Modal.Header>
              <Modal.Body>
                <div className="gis-mapcontainer">
                  {/* <LocationAutoComplete updateMapLocation={updateMapLocation} /> */}

                  <div key={mapKey} className="assetFormMap">
                    <MapWrapper
                      headerStyles={{ display: "none" }}
                      coordinates={coordinates}
                      chooseCoordinates={chooseCoordinates}
                      zoom={zoomLevel}
                      closeMapModal={closeMapModal}
                    />
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          )}
          <Modal
            show={showCancelModal}
            onHide={closeCancelModal}
            centered
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirm</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Would you like to clear the input values?</p>
            </Modal.Body>
            <Modal.Footer style={{ justifyContent: "right" }}>
              <button
                className="btn"
                style={{
                  backgroundColor: "lightgray",
                  color: "#000",
                  marginRight: "10px",
                }}
                onClick={closeCancelModal}
              >
                No
              </button>
              <button
                className="btn"
                style={{
                  backgroundColor: "green",
                  color: "#fff",
                }}
                onClick={confirmCancel}
              >
                Yes
              </button>
            </Modal.Footer>
          </Modal>

          <ToastContainer />
        </>
      ) : (
        <>
          <div className="branch-main-container">
            {/* Tab Content */}
            <div className="tab-content" id="branchTabContent">
              {/* Branch Details Tab */}
              <div
                className="tab-pane fade show active"
                id="branch-details"
                role="tabpanel"
                aria-labelledby="branch-details-tab"
              >
                <div className="main-container">
                  <div className="row">
                    <div className="col-8 mb-3">
                      <label htmlFor="bankName" className="form-label">
                        Bank Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.bankName ? "is-invalid" : ""
                        }`}
                        id="bankName"
                        value={formData.bankName}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        // ="Enter bank name"
                      />
                      {validationErrors.bankName && (
                        <div className="invalid-feedback">
                          {validationErrors.bankName}
                        </div>
                      )}
                    </div>
                    <div className="col-2 mb-3">
                      <label htmlFor="bankName" className="form-label">
                        Font Size (px)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        min="18"
                        max="30"
                        step="1"
                        value={fontStyles.bankNameFontSize}
                        onChange={(e) => {
                          let value = e.target.value;
                          // Ensure value is between 8 and 72
                          if (value > 30) value = 30;
                          if (value < 18) value = 18;
                          setFontStyles({
                            ...fontStyles,
                            bankNameFontSize: value,
                          });
                        }}
                        disabled={isTextFieldDisable}
                      />
                    </div>
                    <div className="col-2 mb-3">
                      <label htmlFor="bankNameColor" className="form-label">
                        Font Color
                        <i
                          className="bi bi-eyedropper"
                          style={{
                            paddingLeft: "5px",
                            fontSize: "16px",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            document.getElementById("bankNameColor").click()
                          }
                        ></i>
                      </label>
                      <input
                        type="color"
                        id="bankNameColor"
                        style={{ width: "50%" }}
                        className="form-control form-control-sm p-1"
                        value={fontStyles.bankNameColor}
                        onChange={(e) =>
                          setFontStyles({
                            ...fontStyles,
                            bankNameColor: e.target.value,
                          })
                        }
                        disabled={isTextFieldDisable}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-3 mb-3">
                      <label htmlFor="district" className="form-label">
                        District<span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-select branch-input-form-control ${
                          validationErrors.district ? "is-invalid" : ""
                        }`}
                        id="district"
                        value={formData.district}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                      >
                        <option value="">Select District</option>
                        {districtList.map((district) => (
                          <option key={district.id} value={district.value}>
                            {district.value}
                          </option>
                        ))}
                      </select>
                      {validationErrors.district && (
                        <div className="invalid-feedback">
                          {validationErrors.district}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="ifscCode" className="form-label">
                        IFSC Code<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.ifscCode ? "is-invalid" : ""
                        }`}
                        id="ifscCode"
                        value={formData.ifscCode}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        // ="Example: DCCB0123456"
                        maxLength={11}
                      />
                      {validationErrors.ifscCode && (
                        <div className="invalid-feedback">
                          {validationErrors.ifscCode}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="activationDate" className="form-label">
                        Active Status
                      </label>
                      <div className="d-flex align-items-center gap-2">
                        <input
                          className="form-check-input branch-active-status-checkbox"
                          type="checkbox"
                          id="activeStatusCheck"
                          checked={formData.activeStatus}
                          onChange={handleInputChange}
                          disabled={isTextFieldDisable}
                        />
                        <input
                          type="date"
                          className={`custom-date-input form-control ${
                            validationErrors.entryDate ? "is-invalid" : ""
                          }`}
                          id="entryDate"
                          style={{paddingBottom: "7px"}}
                          value={formData.entryDate}
                          onChange={handleInputChange}
                          disabled={isTextFieldDisable}
                          max={today}
                        />
                        {validationErrors.entryDate && (
                          <div className="invalid-feedback">
                            {validationErrors.entryDate}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="section-header-branch">
                    <span className="uline">Bank Address</span>
                  </div>
                  <div className="row">
                    <div className="col-3 mb-3">
                      <label htmlFor="addressLine1" className="form-label">
                        Address<span className="text-danger">*</span>
                      </label>
                      <textarea
                        className={`form-control branch-input-form-control ${
                          validationErrors.addressLine1 ? "is-invalid" : ""
                        }`}
                        id="addressLine1"
                        value={formData.addressLine1}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        // ="Enter address"
                        rows={3} // You can adjust rows based on how big you want it
                      />
                      {validationErrors.addressLine1 && (
                        <div className="invalid-feedback">
                          {validationErrors.addressLine1}
                        </div>
                      )}
                    </div>

                    <div className="col-3 mb-3">
                      <label htmlFor="mandal" className="form-label">
                        Mandal<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.mandal ? "is-invalid" : ""
                        }`}
                        id="mandal"
                        value={formData.mandal}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        maxLength={50}
                        // ="Enter mandal name"
                      />
                      {validationErrors.mandal && (
                        <div className="invalid-feedback">
                          {validationErrors.mandal}
                        </div>
                      )}
                    </div>
                    <div className="col-3 mb-3">
                      <label htmlFor="city" className="form-label">
                        City<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.city ? "is-invalid" : ""
                        }`}
                        id="city"
                        value={formData.city}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        maxLength={50}
                        // ="Enter city name"
                      />
                      {validationErrors.city && (
                        <div className="invalid-feedback">
                          {validationErrors.city}
                        </div>
                      )}
                    </div>

                    <div className="col-3 mb-3">
                      <label htmlFor="pinCode" className="form-label">
                        Pincode<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.pinCode ? "is-invalid" : ""
                        }`}
                        id="pinCode"
                        value={formData.pinCode}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        maxLength={6}
                        // ="Enter 6-digit pincode"
                      />
                      {validationErrors.pinCode && (
                        <div className="invalid-feedback">
                          {validationErrors.pinCode}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-3 mb-3">
                      <label htmlFor="latitude" className="form-label mb-0">
                        Latitude
                      </label>
                      <input
                        type="text"
                        className="form-control branch-input-form-control mt-1"
                        id="latitude"
                        value={formData.latitude}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        readOnly
                      />
                      {validationErrors.latitude && (
                        <div className="text-danger small">
                          {validationErrors.latitude}
                        </div>
                      )}
                    </div>

                    <div className="col-3 mb-3">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <label htmlFor="longitude" className="form-label ">
                          Longitude
                        </label>
                        <span
                          className="text-primary"
                          onClick={
                            !isTextFieldDisable ? openMapModal : undefined
                          }
                          style={{
                            cursor: isTextFieldDisable
                              ? "not-allowed"
                              : "pointer",
                            opacity: isTextFieldDisable ? 0.5 : 1,
                            fontSize: "14px",
                          }}
                        >
                          Locate on map
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control branch-input-form-control"
                        id="longitude"
                        value={formData.longitude}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        readOnly
                      />
                      {validationErrors.longitude && (
                        <div className="text-danger small">
                          {validationErrors.longitude}
                        </div>
                      )}
                    </div>

                    <div className="col-6 mb-3">
                      {mapview && (
                        <div>
                          <MapWrapperForEdit
                            bankEdit={true}
                            title="Incidents"
                            containerStyles={{
                              height: "60%",
                              borderRadius: "10px",
                              // height: "100vh",
                              display: "flex",
                              flexDirection: "column",
                            }}
                            headerStyles={{
                              backgroundColor: "#1a7a73",
                              color: "white",
                              padding: "8px 16px",
                            }}
                            bodyStyles={{
                              flex: 1,
                              overflow: "hidden",
                            }}
                            coordinates={mapCoordinates}
                            zoom={13}
                            popUpShow={true}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div
                    className="section-header-branch"
                    style={{ marginTop: "-27rem" }}
                  >
                    <span className="uline">Bank Contact Details</span>
                  </div>
                  <div className="row">
                    <div className="col-6 mb-3">
                      <label htmlFor="phoneNumber" className="form-label">
                        Mobile/Landline Number
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.phoneNumber ? "is-invalid" : ""
                        }`}
                        id="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        // ="Mobile: 10 digits, Landline: STD code + number"
                      />
                      {validationErrors.phoneNumber && (
                        <div className="invalid-feedback">
                          {validationErrors.phoneNumber}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Update the Contact Name field */}
                  <div className="row">
                    <div className="col-6 mb-3">
                      <label htmlFor="contactName" className="form-label">
                        Contact Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.contactName ? "is-invalid" : ""
                        }`}
                        id="contactName"
                        value={formData.contactName}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        // ="Enter contact person name"
                      />
                      {validationErrors.contactName && (
                        <div className="invalid-feedback">
                          {validationErrors.contactName}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 mb-3">
                      <label htmlFor="email" className="form-label">
                        Email Address<span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className={`form-control branch-input-form-control ${
                          validationErrors.email ? "is-invalid" : ""
                        }`}
                        id="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        // ="Enter email address e.g. user@example.com"
                      />
                      {validationErrors.email && (
                        <div className="invalid-feedback">
                          {validationErrors.email}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Update the Website field */}
                  <div className="row">
                    <div className="col-6 mb-3">
                      <label htmlFor="website" className="form-label">
                        Website
                      </label>
                      <input
                        type="text"
                        className={`form-control branch-input-form-control ${
                          validationErrors.website ? "is-invalid" : ""
                        }`}
                        id="website"
                        value={formData.website}
                        onChange={handleInputChange}
                        disabled={isTextFieldDisable}
                        // ="Enter website URL e.g. example.com"
                      />
                      {validationErrors.website && (
                        <div className="invalid-feedback">
                          {validationErrors.website}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 mb-3">
                      <label htmlFor="bankLogo" className="form-label">
                        Bank Logo
                      </label>
                      <input
                        type="file"
                        id="bankLogo"
                        accept=".jpg, .jpeg, .png, .svg, image/jpeg, image/png, image/svg+xml"
                        onChange={handleLogoChange}
                        className="form-control branch-input-form-control"
                      />
                      {logoPreview && (
                        <div
                          className="mt-2 position-relative"
                          style={{ width: "100px", height: "100px" }}
                        >
                          <img
                            src={logoPreview}
                            alt="Bank Logo Preview"
                            className="img-thumbnail"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                            }}
                          />
                          {!isTextFieldDisable && (
                            <button
                              onClick={handleLogoRemove}
                              className="position-absolute top-0 end-0 bg-danger border-0 rounded-circle p-0"
                              style={{
                                width: "24px",
                                height: "24px",
                                transform: "translate(50%, -50%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              aria-label="Remove logo"
                            >
                              <span
                                style={{ color: "white", fontSize: "12px" }}
                              >
                                ×
                              </span>
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="d-flex justify-content-center mt-3">
                    <button
                      style={{ marginTop: "2rem" }}
                      className="branch-save-submit-btn btn btn-success"
                      onClick={handleSubmit}
                      disabled={isSubmitting || isTextFieldDisable}
                    >
                      {isSubmitting
                        ? "Submitting..."
                        : mapview
                        ? "Update"
                        : "Save & Submit"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Display loading indicator */}
          {loader && (
            <div className="loader-container">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          {showMapModal && (
            <Modal
              className="modal-position"
              size="lg"
              show={showMapModal}
              onHide={closeMapModal}
              aria-labelledby="example-modal-sizes-title-lg"
              right
            >
              <Modal.Header>
                <Modal.Title
                  id="example-modal-sizes-title-lg"
                  style={{ color: "#001b30", marginRight: "500px" }}
                >
                  {"Choose Location"}
                </Modal.Title>
                <XCircleblack
                  className="cursor-pointer"
                  onClick={closeMapModal}
                  width="1.5em"
                  height="1.5em"
                  style={{ color: "#001b30" }}
                />
              </Modal.Header>
              <Modal.Body>
                <div className="gis-mapcontainer">
                  {/* <LocationAutoComplete updateMapLocation={updateMapLocation} /> */}

                  <div key={mapKey} className="assetFormMap">
                    <MapWrapper
                      headerStyles={{ display: "none" }}
                      coordinates={coordinates}
                      chooseCoordinates={chooseCoordinates}
                      zoom={zoomLevel}
                      closeMapModal={closeMapModal}
                    />
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          )}

          <ToastContainer />
        </>
      )}
    </>
  );
};

export default CreateBankForm;
